import { useCallback, useState } from 'react'
import * as S from './styles'
import { HomepageCarouselSlide } from '../../../../models/homepage-carousel/homepage-carousel-slide'
import HomepageCarouselRowComponent from '../HomepageCarouselRowComponent'
import { HomepageCarouselHelper } from '../../../../helpers/homepage-carousel-helper'
import { ActionButton } from '../../../atoms'

const MAX_SLIDES = 10

export interface HomepageCarouselRowsComponentProps {
    slides: HomepageCarouselSlide[]
    channel: string
    onSlidesAdded: (newSlides: HomepageCarouselSlide[]) => void
    onSlideDeleted: (slideId: string) => void
}

const HomepageCarouselRowsComponent: React.FC<HomepageCarouselRowsComponentProps> =
    (props) => {
        const [isAdding, setIsAdding] = useState(false)

        const atMaxCapacity = props.slides.length >= MAX_SLIDES

        const handleAddSlides = useCallback(async () => {
            if (atMaxCapacity) return
            setIsAdding(true)
            const res = await HomepageCarouselHelper.addSlidesAsync(props.channel, 1)
            setIsAdding(false)

            if (res.kind === 'error') {
                console.error(res.errorData)
                return
            }

            props.onSlidesAdded(res.data)
        }, [props.channel, props.onSlidesAdded, atMaxCapacity])

        return (
            <>
                <S.MainBox>
                    <S.RowsBox>
                        {props.slides.map((slide, index) => (
                            <div key={slide._id}>
                                <HomepageCarouselRowComponent
                                    slide={slide}
                                    slideNumber={index + 1}
                                    onSlideDeleted={props.onSlideDeleted}
                                />
                            </div>
                        ))}
                    </S.RowsBox>
                    <S.AddButtonBox>
                        <ActionButton
                            isDisabled={isAdding || atMaxCapacity}
                            onClick={handleAddSlides}
                        >
                            {isAdding ? 'Adding…' : '+ Add Slide'}
                        </ActionButton>
                        {
                            atMaxCapacity && (
                                <S.SlideCountLabel atMax={atMaxCapacity}>
                                    {props.slides.length} / {MAX_SLIDES} slides
                                    {atMaxCapacity && ' — maximum reached'}
                                </S.SlideCountLabel>
                            )
                        }
                    </S.AddButtonBox>
                </S.MainBox>
            </>
        )
    }

export default HomepageCarouselRowsComponent
